module.exports = __webpack_public_path__ + "static/img/floorAreaSvgReference_existing.faec7cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/floorAreaSvgReference_existing.jpg
// module id = 0rXu
// module chunks = 1 2